export default {
	loading: '加载中...',
	add: '新增',
	delete: '删除',
	edit: '修改',
	query: '查询',
	export: '导出',
	handle: '操作',
	back: '返回',
	home: '首页',
	confirm: '确定',
	cancel: '取消',
	clear: '清除',
	close: '关闭',
	createTime: '创建时间',
	updateTime: '更新时间',
	required: '必填项不能为空',
	app: {
		title: '',
		description:
			'基于SpringBoot、SpringSecurity、Mybatis-Plus、Vue3、TypeScript、Element Plus、Vue Router、Pinia、Axios、i18n、Vite等开发的后台脚手架，使用门槛极低！',
		logoText: '设备全生命周期管理平台',
		miniLogoText: '五矿盐湖',
		username: '用户名',
		password: '密码',
		captcha: '验证码',
		signIn: '登录',
		mobileSignIn: '手机登录',
		mobile: '手机号',
		signOut: '退出',
		profile: '个人中心',
		large: '大型',
		default: '默认',
		small: '小型',
		close: '关闭当前',
		closeOthers: '关闭其它',
		closeAll: '关闭全部'
	},
	settings: {
		title: '布局设置',
		sidebarDark: '暗色侧边栏',
		sidebarLight: '亮色侧边栏',
		navbarLight: '亮色顶栏',
		navbarTheme: '主题色顶栏',
		layout: '布局切换',
		vertical: '纵向',
		columns: '分栏',
		transverse: '横向',
		interface: '界面设置',
		dark: '开启暗黑模式',
		uniqueOpened: '侧栏排他展开',
		logo: '开启LOGO',
		breadcrumb: '开启面包屑',
		tabs: '开启标签页',
		tabsCache: '开启标签页缓存',
		defaultPlatform: '默认主平台',
		platType: '平台风格',
		tabsStyle: '标签页风格',
		tips: '设置之后仅是临时生效，要想永久生效，需点击下方的 "复制配置" 按钮，将配置替换到 store/theme/config.ts 中。',
		copyConfig: '复制配置',
		reset: '恢复默认',
		copySuc: '复制成功',
		style1: '风格1',
		style2: '风格2',
		intelligent: '智能运维平台',
		lifecycle: '设备全生命周期',
		platTypeDefault: '默认风格',
		platTypeSmart: '智能运维风格',
		langSwitch: '语言切换',
		alarmBroadcast: '告警播报',
		alarmQRCode: '告警二维码',
		appDownload: 'APP下载',
		aiAssistant: 'AI助手',
		fullscreen: '全屏/退出全屏',
		exitFullscreen: '全屏/退出全屏'
		// layoutView: '显示布局'
	},
	common: {
		save: '保存',
		reset: '重置',
		delete: '删除',
		edit: '编辑',
		cancel: '取消',
		confirm: '确定',
		back: '返回'
	},
	profile: {
		title: '个人信息',
		basicInfo: '基本信息',
		basicData: '基本资料',
		changePassword: '修改密码',
		uploadAvatar: '请上传头像',
		platformLogo: '平台Logo',
		uploadPlatformLogo: '请上传平台Logo',
		username: '用户名',
		realName: '姓名',
		mobile: '手机号码',
		email: '用户邮箱',
		orgName: '所属机构',
		postName: '所属岗位',
		createTime: '创建日期',
		encryptPassword: '加密密码',
		currentPassword: '当前密码',
		noData: '暂无数据',
		authTitle: '为了安全，请输入当前登录密码以查看加密密码',
		authMessage: '身份验证',
		passwordRequired: '密码不能为空',
		modifySuccess: '修改成功',
		gender: '性别',
		phonePlaceholder: '手机号码',
		emailPlaceholder: '邮箱',
		namePlaceholder: '姓名',
		freeLogin: '免密登录',
		freeLoginTip: '免密链接包含加密后的登录密码，拿到链接即可直接登录系统。',
		basicParams: '基础参数',
		displayParams: '显示参数',
		baseUrl: '系统地址',
		baseUrlPlaceholder: '',
		baseUrlRequired: '请输入系统地址',
		usernamePlaceholder: '请输入用户名',
		usernameRequired: '请输入用户名',
		loginPassword: '登录密码',
		loginPasswordPlaceholder: '请输入当前登录密码，用于生成加密密码',
		loginPasswordRequired: '请输入登录密码',
		targetPage: '目标页面',
		targetPagePlaceholder: '默认 /screen，可输入其他页面路径',
		targetPageRequired: '请选择目标页面',
		showMenu: '显示菜单',
		showMenuHint: '打开链接后显示左侧菜单与顶部导航（show_menu=true）',
		showSettings: '显示设置',
		showSettingsHint: '打开链接后显示设置按钮（show_settings=true）',
		hiddenTree: '隐藏左侧树',
		hiddenTreeHint: '打开链接后隐藏页面左侧树（is_hidden_true=true）',
		generateLink: '生成免密链接',
		generateLinkSuccess: '免密链接生成成功',
		generateLinkFailed: '免密链接生成失败，请检查参数',
		resetLink: '重置',
		generatedLink: '生成的免密链接',
		generatedLinkPlaceholder: '填写参数后点击「生成免密链接」',
		copyLink: '复制链接',
		copyLinkSuccess: '链接已复制到剪贴板',
		copyLinkFailed: '复制失败，请手动选中复制',
		openLink: '打开链接',
		qrcode: '二维码',
		scanTip: '可使用平板或手机扫码直接打开',
		thirdParty: {
			title: '第三方登录',
			serialNumber: '序号',
			platformType: '平台类型',
			wechatWork: '企业微信',
			dingtalk: '钉钉',
			feishu: '飞书',
			wechat: '微信',
			nickname: '昵称',
			status: '状态',
			unbound: '未绑定',
			bound: '已绑定',
			bind: '绑定',
			unbind: '解绑',
			operationSuccess: '操作成功'
		}
	},
	sys: {
		common: {
			batchDelete: '批量删除',
			reset: '重置',
			platformType: '平台类型',
			groupName: '分组名称',
			status: '状态',
			pleaseSelect: '请选择',
			parentNode: '上级节点',
			pleaseSelectParent: '请选择上级',
			sort: '排序',
			operationSuccess: '操作成功',
			operationFailed: '操作失败，请重试'
		},
		attachment: {
			upload: '上传',
			batchDelete: '批量删除',
			action: {
				download: '下载',
				preview: '预览'
			},
			uploadFailed: '上传失败：',
			uploadSuccess: '上传成功',
			fileTooLarge: '文件大小不能超过100M',
			query: {
				bizType: '业务类型',
				name: '附件名称',
				fileType: '附件类型'
			},
			table: {
				name: '附件名称',
				fileType: '文件类型',
				size: '大小',
				platform: '存储平台',
				bizType: '业务类型'
			}
		},
		config: {
			sms: {
				title: '短信配置',
				signName: '短信签名',
				templateId: '短信模板',
				groupNameHint: '分组名称相同的配置，会轮询发送短信',
				url: '接入地址',
				urlHint: 'APP接入地址',
				senderIdIntlHint: '国际短信必填',
				channelNo: '通道号',
				channelNoHint: '通道号必填'
			},
			mail: {
				title: '邮件配置',
				groupNameHint: '分组名称相同的配置，会轮询发送邮件',
				mailFrom: '邮箱账号',
				mailFromPlaceholder: '发件邮箱',
				mailPass: '邮箱密码',
				mailHost: 'SMTP服务器',
				mailHostHint: '企业邮箱或自建的，必须要填写',
				mailPort: 'SMTP端口',
				mailPortHint: '默认25端口',
				endpointHint: '阿里云 endpoint'
			},
			third: {
				title: '第三方登录'
			}
		},
		menu: {
			expandAll: '全部展开',
			collapseAll: '全部收起',
			table: {
				name: '名称',
				icon: '图标',
				type: '类型',
				openStyle: '打开方式',
				sort: '排序',
				route: '路由',
				authority: '授权标识'
			},
			type: {
				menu: '菜单',
				button: '按钮',
				api: '接口'
			},
			openStyle: {
				internal: '内部打开',
				external: '外部打开'
			},
			permissionButtonConfig: '配置权限按钮',
			addPermissionButtonsTitle: '添加权限按钮（增删查改）',
			submit: '提交',
			operationSuccess: '操作成功',
			operationFailed: '操作失败，请重试',
			permission: {
				view: '查看',
				add: '新增',
				edit: '修改',
				delete: '删除'
			},
			form: {
				type: '类型',
				name: '名称',
				parent: '上级菜单',
				route: '路由',
				sort: '排序',
				openStyle: '打开方式',
				display: '是否显示',
				authority: '授权标识',
				authorityPlaceholder: '多个用逗号分隔，如：sys:menu:save,sys:menu:update',
				icon: '图标'
			},
			display: {
				show: '显示',
				hide: '隐藏'
			}
		},
		org: {
			table: {
				name: '名称',
				path: '路径'
			},
			form: {
				gridLayout: '格栅布局',
				parentDept: '上级部门',
				orgPlaceholder: '机构',
				name: '名称',
				leader: '负责人'
			}
		},
		dict: {
			type: {
				query: {
					dictType: '字典类型',
					dictName: '字典名称'
				},
				table: {
					dictType: '字典类型',
					dictName: '字典名称',
					remark: '备注',
					source: '数据来源'
				},
				source: {
					dictData: '字典数据',
					dynamicSql: '动态SQL'
				},
				action: {
					dictConfig: '字典配置',
					dynamicData: '动态数据'
				},
				drawer: {
					dictConfig: '字典配置',
					dynamicData: '动态数据'
				},
				form: {
					dictType: '字典类型',
					dictName: '字典名称',
					remark: '备注',
					source: '数据来源',
					dictSql: '动态SQL',
					dictSqlPlaceholder: '如：select id as dictValue, name as dictLabel from sys_role where deleted = 0'
				}
			},
			data: {
				table: {
					dictValue: '字典值',
					dictLabel: '字典标签'
				},
				form: {
					dictValue: '字典值',
					dictLabel: '字典标签',
					labelClass: '标签样式',
					remark: '备注'
				}
			}
		},
		user: {
			import: '导入',
			exportFile: '导出文件',
			table: {
				username: '用户名',
				realName: '姓名',
				gender: '性别',
				status: '状态',
				mobile: '手机号',
				orgName: '所属机构',
				accountExpireTime: '账号过期时间',
				passwordExpireTime: '密码过期时间'
			},
			query: {
				username: '用户名',
				mobile: '手机号',
				gender: '性别',
				orgId: '所属机构'
			},
			form: {
				username: '用户名',
				realName: '姓名',
				gender: '性别',
				email: '邮箱',
				wecomId: '企业微信id',
				mobile: '手机号',
				password: '密码',
				orgId: '所属机构',
				inspectOrgId: '机构（诊断）',
				roleIdList: '所属角色',
				postIdList: '所属岗位',
				wechatLevel: '微信告警等级',
				wecomLevel: '企业微信告警等级',
				wechatLevelPlaceholder: '微信公众号告警等级',
				wecomLevelPlaceholder: '企业微信公众号告警等级',
				smsLevel: '短信告警等级',
				mailLevel: '邮件告警等级',
				tokenExpireTime: 'token过期时间',
				tokenExpireTimePlaceholder: '请选择token过期时间',
				accountExpireTime: '账号过期时间',
				accountExpireTimePlaceholder: '请选择账号过期时间',
				passwordExpireTime: '密码过期时间',
				passwordExpireTimePlaceholder: '请选择密码过期时间',
			warnType: '推送告警类型',
			generalWarnPushInterval: '一般告警推送间隔',
			mediumWarnPushInterval: '中等告警推送间隔',
			pushIntervalUnitPlaceholder: '单位小时'
		},
			level: {
				normal: '一般等级',
				medium: '中等等级',
				severe: '严重等级',
				none: '不告警'
			},
			validation: {
				mobileFormat: '请输入正确的手机号格式'
			}
		}
	},

	appDownload: {
		title: '移动端 APP 下载',
		qrcodeTip: '扫描二维码下载 APP',
		manualTitle: '操作手册',
                manualPreview: '操作手册',
		viewManual: '查看操作手册'
	},
	notifications: {
		title: '消息通知',
		system: '系统通知',
		markAllRead: '全部标为已读',
		clearAll: '清空全部',
		noNotifications: '暂无消息',
		viewAll: '查看全部',
		detail: '通知详情',
		warnNotice: '告警通知',
		workOrderNotice: '工单通知',
		sensorStatus: '测点状态变更通知',
		lowBattery: '低电量告警',
		handleWarn: '处理告警',
		handleOrder: '处理工单',
		back: '返回'
	},
	designForm: {
		widgetLibrary: '控件库',
		formDesign: '表单设计',
		formConfig: '表单配置',
		fieldSettings: '字段设置',
		add: '添加',
		delete: '删除',
		copy: '复制',
		moveUp: '上移',
		moveDown: '下移',
		label: '标签',
		placeholder: '占位符',
		required: '必填',
		defaultValue: '默认值',
		hint: '提示',
		validation: '验证',
		width: '宽度',
		height: '高度',
		precision: '精度',
		min: '最小值',
		max: '最大值',
		format: '格式',
		multiple: '多选',
		clearable: '可清空',
		filterable: '可搜索',
		options: '选项',
		optionValue: '值',
		optionLabel: '标签',
		addOption: '添加选项',
		save: '保存',
		cancel: '取消',
		reset: '重置',
		preview: '预览',
		generateCode: '生成代码',
		jsonEditor: 'JSON 编辑器',
		import: '导入',
		emptyWidget: '未选择组件',
		fieldKey: '字段标识',
		title: '标题',
		staticData: '静态数据',
		varAssign: '赋值变量',
		dictData: '数据字典',
		setOptionValue: '设置选项值',
		varName: '变量名称',
		dictKey: '数据字典Key',
		buttonStyle: '按钮样式',
		opProps: '操作属性',
		readonly: '只读',
		disabled: '禁用',
		clear: '清除',
		hideLabel: '隐藏标签',
		showPassword: '显示密码',
		showWordLimit: '显示统计字数',
		validate: '校验',
		customError: '自定义错误提示',
		string: '字符串',
		url: 'URL地址',
		email: '邮箱地址',
		pattern: '正则表达式',
		patternPlaceholder: '填写正则表达式',
		designerTitle: 'MAKU - 表单设计器',
		importJson: '导入JSON',
		generateJson: '生成JSON',
		clickUpload: '点击上传',
		dragTip: '从左侧拖拽来添加字段',
		widgetTypes: {
			input: '输入框',
			textarea: '文本域',
			number: '数字输入',
			select: '选择器',
			radio: '单选框',
			checkbox: '复选框',
			switch: '开关',
			date: '日期选择',
			time: '时间选择',
			rating: '评分',
			slider: '滑块',
			editor: '富文本编辑器',
			upload: '上传',
			cascader: '级联选择器',
			treeSelect: '树形选择器',
			divider: '分割线',
			text: '文字'
		}
	},
	maComponents: {
		pleaseSelect: '请选择',
		pleaseInput: '请输入',
		loading: '加载中...',
		noData: '暂无数据',
		expandAll: '展开全部',
		collapseAll: '收起全部',
		device: {
			selectDevice: '选择设备',
			deviceName: '设备名称',
			deviceType: '设备类型',
			deviceModel: '设备型号'
		},
		dict: {
			selectDict: '选择字典',
			dictType: '字典类型',
			dictValue: '字典值',
			dictLabel: '字典标签'
		},
		org: {
			selectOrg: '选择机构',
			orgName: '机构名称',
			parentOrg: '上级机构'
		},
		user: {
			selectUser: '选择用户',
			username: '用户名',
			realName: '姓名',
			mobile: '手机号',
			createTime: '创建时间'
		},
		post: {
			selectPost: '选择岗位',
			postName: '岗位名称'
		},
		report: {
			selectReport: '选择报表',
			reportName: '报表名称'
		},
		address: {
			selectAddress: '选择地址',
			province: '省份',
			city: '城市',
			district: '区县'
		},
		icon: {
			selectIcon: '选择图标',
			iconName: '图标名称'
		}
	},
	partSelect: {
		title: '备品备件领取',
		name: '名称',
		erpCode: 'ERP 物料编码',
		stockQuantity: '库存数量',
		receiveQuantity: '领取数量',
		namePlaceholder: '请输入名称',
		saveSuccess: '保存成功',
		saveFailed: '保存失败'
	},
	deviceList: {
		toggle2D: '切换 2D',
		toggle3D: '切换 3D',
		sensorGroup: '测点分组',
		configDeviceModel: '配置设备模型图',
		sensorManager: '测点管理',
		selectAll: '全选',
		clearAll: '清空',
		maxSensorsTip: '最多可显示 20 个测点',
		addGroup: '新增测点分组',
		editGroup: '编辑测点分组',
		groupName: '分组名称',
		groupNameRequired: '请输入分组名称',
		groupNamePlaceholder: '请输入分组名称',
		selectSensor: '选择测点',
		searchSensor: '搜索测点名称',
		noOptionalSensors: '暂无可选测点'
	},
	deviceImg: {
		savePosition: '保存位置信息',
		positionSaved: '点位信息保存成功',
		positionSaveFailed: '点位信息保存失败'
	},
	maUpload: {
		image: {
			edit: '编辑',
			view: '查看',
			delete: '删除',
			upload: '上传',
			uploadSuccess: '上传成功',
			uploadFailed: '上传失败',
			fileTooLarge: '文件大小不能超过{size}MB',
			unsupportedType: '不支持的文件类型',
			confirmDelete: '确定要删除此图片吗？'
		}
	},
	screen: {
		empty: {
			noData: '暂无数据',
			noChart: '暂无图表'
		},
		itemWrap: {
			loading: '加载中...'
		},
		common: {
			timeRange: {
				last7Days: '最近7天',
				last1Month: '最近1个月',
				last3Months: '最近3个月'
			},
			status: {
				running: '运行',
				online: '在线',
				stopped: '停机',
				offline: '离线',
				unknown: '未知'
			},
			alarmLevel: {
				normal: '正常',
				general: '一般',
				medium: '中等',
				severe: '严重',
				emergency: '紧急',
				generalAlarm: '一般告警',
				mediumAlarm: '中等告警',
				severeAlarm: '严重告警'
			},
			device: {
				countUnit: '台',
				deviceCountWithUnit: '设备数量(台)',
				processPointCount: '工艺测点(个)',
				warnPointCount: '告警测点数(个)'
			}
		},
		index: {
			headerTitle: '智能运维平台',
			deviceHealthRank: '设备健康度排名',
			deviceTypeStats: '设备类型统计',
			dailyRunStats: '每日设备运行统计',
			deviceAlarmStats: '设备告警统计(台)',
			last7DaysAlarmHandle: '近7天告警处理',
			last7DaysNewAlarm: '近7天新增告警'
		},
		topc: {
			refreshTooltip: '刷新页面数据',
			profile: '个人中心',
			alarmQrcode: '告警二维码',
			appDownload: 'APP下载',
			logout: '退出登录',
			bindPhoneRequired: '用户需先绑定手机号',
			warnQrcodeDialogTitle: '告警通知二维码'
		},
		contentCenter: {
			mapMode: '地图模式',
			deviceMode: '设备模式',
			mapConfig: '地图配置',
			noDeviceData: '暂无设备数据',
			pauseAutoPlay: '暂停自动播放',
			startAutoPlay: '开始自动播放',
			mapJson: '地图JSON',
			uploadJson: '点击上传',
			mapPointInfo: '地图点位信息',
			selectDept: '选择部门',
			pointName: '点位名称',
			pointNamePlaceholder: '请输入点位名称',
			longitude: '经度',
			longitudePlaceholder: '请输入经度',
			latitude: '纬度',
			latitudePlaceholder: '请输入纬度',
			addPoint: '添加点位',
			cancel: '取消',
			saveConfig: '保存配置',
			saveSuccess: '地图配置保存成功',
			saveFailed: '请检查表单填写是否正确',
			runningStatusTitle: '设备运行状态',
			columnIndex: '序号',
			columnDeviceName: '设备名称',
			columnDeviceNumber: '设备编号',
			columnStatus: '运行状态',
			columnDuration: '时长',
			columnAlarmLevel: '告警等级',
			descriptionPrefix: '设备类型：'
		},
		leftTop: {
			deviceCountSeriesName: '设备数量'
		},
		leftCenter: {
			totalLabel: '总数',
			tooltipUnit: '台',
			seriesName: '设备类型统计'
		},
		leftBottom: {
			seriesRun: '运行',
			seriesStop: '停机',
			seriesOffline: '离线'
		},
		rightTop: {
			levelSevere: '严重',
			levelMedium: '中等',
			levelGeneral: '一般',
			levelNormal: '正常',
			levelEmergency: '紧急'
		},
		rightCenter: {
			handledAlarm: '已处理告警',
			pendingAlarm: '待处理告警'
		},
		rightBottom: {
			levelSevere: '严重',
			levelMedium: '中等',
			levelGeneral: '一般'
		},
		factoryDetails: {
			selectFactory: '选择工厂',
			totalAlarm: '告警总数',
			totalDevice: '设备总数',
			totalSensor: '测点总数',
			totalOrder: '工单总数',
			recentAlarm: '近期告警',
			noAlarm: '暂无告警',
			uploadFactoryImage: '上传工厂图',
			savePosition: '保存位置',
			editPosition: '编辑位置',
			dragTip: '拖拽区域标记可调整位置',
			deviceCount: '设备数',
			alarmCount: '告警数',
			orderCount: '工单数',
			saveSuccess: '保存成功',
			saveFailed: '保存失败'
		},
		weather: {
			defaultWeather: '晴'
		}
	},
	charts: {
		loading: '图表加载中...',
		noData: '暂无数据',
		export: '导出',
		refresh: '刷新',
		fullscreen: '全屏',
		settings: '设置',
		dataZoom: '区域缩放',
		restore: '还原',
		peakCount: {
			title: '峰值统计',
			index: '序号',
			frequency: '频率 (Hz)',
			amplitude: '幅值'
		}
	},
	processDesigner: {
		title: '流程设计器',
		properties: '属性面板',
		baseInfo: '基本信息',
		formConfig: '表单配置',
		listeners: '监听器',
		multiInstance: '多实例',
		otherConfig: '其他配置',
		save: '保存',
		preview: '预览',
		validate: '验证',
		import: '导入',
		export: '导出',
		undo: '撤销',
		redo: '重做',
		zoomIn: '放大',
		zoomOut: '缩小',
		taskConfig: {
			assignee: '办理人',
			candidateUsers: '候选用户',
			candidateGroups: '候选组',
			dueDate: '截止日期',
			priority: '优先级',
			formKey: '表单 key',
			skipExpression: '跳过表达式'
		},
		flowCondition: {
			conditionExpression: '条件表达式',
			sequenceFlow: '流程线'
		}
	},
	framework: {
		common: {
			tip: '提示',
			operationSuccess: '操作成功',
			operationFailed: '操作失败',
			all: '全部',
			detail: '详情',
			ignore: '忽略',
			setting: '设置'
		},
		notifications: {
			unread: '未读消息',
			unreadInfo: '未读信息',
			initiator: '发起人',
			content: '内容',
			confirmIgnore: '确定进行忽略操作?',
			source: '通知来源：',
			time: '通知时间：'
		},
		tenant: {
			title: '切换租户',
			tenantId: '租户ID',
			tenantName: '租户名称',
			status: '状态',
			query: '查询',
			pleaseSelect: '请选择需切换的租户'
		},
		theme: {
			light: '明亮主题',
			dark: '暗黑主题',
			blue: '蓝色主题',
			blueX: '蓝X主题',
			sidebarDeepBlue: '深蓝侧边',
			navbarDeepBlue: '深蓝顶栏'
		},
		navbar: {
			menuSearch: '菜单搜索'
		},
		loginTimeout: {
			message: '登录超时，请重新登录',
			relogin: '重新登录'
		},
		validation: {
			email: '邮箱格式不正确',
			passwordMinLength: '密码不能少于8位',
			passwordStrength: '密码必须包含大小写字母、数字和符号',
			mobile: '手机号格式不正确'
		},
		alarmMode: {
			title: '告警播报模式切换',
			placeholder: '请选择告警播报模式',
			none: '不播报',
			newOnly: '新增播报',
			loop: '循环播报'
		},
		ai: {
			deepThinking: '深度思考',
			modelGeneral: '高泛化诊断大模型',
			modelVertical: 'PHM垂直大模型'
		},
		chart: {
			resetZoom: '重置',
			drag: '拖动'
		},
		upload: {
			tip: '温馨提示',
			invalidImageType: '上传图片不符合所需的格式！',
			imageSizeLimit: '上传图片大小不能超过 {size}M！'
		},
		passwordExpire: {
			title: '密码已过期',
			message: '您的密码已到期（超过90天未更新），为了账户安全，请立即修改密码后重新登录',
			modifying: '修改中...',
			confirm: '确认修改'
		},
		routeTitle: {
			device3d: '3D数字面板',
			deviceDetail: '设备详情',
			factoryDetail: '工厂详情',
			deviceAnnotation: '设备标注',
			profile: '个人中心',
			onlineForm: '在线表单',
			onlineReport: '在线报表',
			deviceList: '设备列表'
		}
	},
	login: {
		welcome: '欢迎登录',
		usernamePlaceholder: '输入用户名',
		passwordPlaceholder: '输入密码',
		remember: '记住用户名密码',
		selectPlatform: '请选择您要进入的平台',
		bindTotp: '绑定双因子认证',
		totp: '双因子认证',
		totpScanStep: '步骤1：扫描二维码',
		totpScanTip: '使用TOTP安全认证器扫描下方二维码：',
		totpCodeStep: '步骤2：输入动态口令',
		totpCodeStepVerify: '输入动态口令',
		totpCodeTip: '请输入认证器中显示的6位动态口令：',
		totpCodeTipVerify: '请输入您的双因子认证动态口令：',
		totpCodePlaceholder: '请输入6位动态口令',
		verifying: '验证中...',
		verifyAndLogin: '验证并登录',
		verifyLogin: '验证登录',
		usernamePasswordRequired: '请输入用户名和密码',
		accountExpired: '账号已过期，请联系相关人员续费',
		totpInitFailed: '初始化双因子认证失败',
		totpCodeRequired: '请输入6位动态口令',
		totpVerifySuccess: '双因子认证验证成功',
		totpCanceled: '已取消双因子认证，请重新登录',
		passwordChanged: '密码修改成功，请使用新密码重新登录',
		passwordChangeCanceled: '已取消密码修改',
		imageBase: '底座',
		imageLine: '分割线',
		imageUser: '用户图标',
		imagePassword: '密码图标'
	}
}
